import { useEffect, useState } from 'react'
import { Currencies } from '../../../helpers/currency/getCurrencySymbol'

export default function getBetReply(obj: any, prec: number, id: any) {
  const defaultObj = {
    user_id: '',
    username: '',
    bet_id: 0,
    round_id: '',
    bet_amount: 0,
    win_amount: 0,
    currency: '',
    coeff: 0,
    client_seed: '',
    server_seed: '',
    server_seed_hash: '',
    nonce: 0,
    date: '',
    rolled: '',
    over_or_under: 0,
    boundary: 0,
  }
  const [betReplyObj, setBetreplyObj] = useState(defaultObj)

  useEffect(() => {
    obj !== undefined ? setBetreplyObj(obj) : setBetreplyObj(defaultObj)
  }, [obj])


  const {
    username,
    bet_id,
    client_seed,
    server_seed_hash,
    server_seed,
    nonce,
    bet_amount,
    win_amount,
    currency,
    date,
    rolled,
    over_or_under,
    boundary,
    user_id,
    round_id,
    coeff,
  } = betReplyObj

  const USER_ID = user_id

  const USER_NAME =
    user_id === id
      ? username
      : username.slice(0, 1) +
      '***' +
      username.slice(username.length - 1, username.length)

  const BET_ID = {
    title: 'Bet Info',
    content: bet_id,
    roundId: round_id,
  }
  const BET_INFO = [
    {
      title: 'User',
      content: username !== '' ? USER_NAME : '-',
    },
    {
      title: 'Multiplier',
      content: coeff === 0 ? '0.00 x' : coeff + 'x',
    },
    {
      title: 'Bet Amount',
      content:
        bet_amount !== 0 &&
        Currencies[currency].symbol + (+bet_amount.toString()).toFixed(prec),
    },
    {
      title: 'Win Amount',
      content:
        Number(win_amount) <= 0
          ? currency
            ? Currencies[currency].symbol + '0.00'
            : '0.00'
          : Currencies[currency].symbol + win_amount,
    },
    {
      title: 'Time',
      content: date ? date.split(' ')[1] : '-',
    },
    {
      title: 'Game',
      content: boundary
        ? (over_or_under === 0 ? '<' : '>') + (+boundary).toFixed(2)
        : '-',
    },

    {
      title: 'Roll',
      content: rolled ? (+rolled).toFixed(2) : '-',
    },
    {
      title: 'Currncy',
      content: currency ? currency : '-',
    },
  ]
  const SEED = [
    {
      title: 'Clients seed',
      content: client_seed,
      enableCopy: client_seed ? true : false,
    },

    server_seed != ''
      ? {
        title: 'Server seed',
        content: server_seed,
        enableCopy: server_seed ? true : false,
      }
      : {
        title: 'Server seed hash',
        content: server_seed_hash,
        enableCopy: server_seed_hash ? true : false,
      },

    {
      title: 'Nonce',
      content: nonce,
      enableCopy: nonce > 0 ? true : false,
    },
  ]
  return { SEED, BET_ID, BET_INFO, USER_ID }
}
